import { render, staticRenderFns } from "./ImprestSurrenderDocument.vue?vue&type=template&id=a61305f0&scoped=true"
import script from "./ImprestSurrenderDocument.vue?vue&type=script&lang=js"
export * from "./ImprestSurrenderDocument.vue?vue&type=script&lang=js"
import style0 from "./ImprestSurrenderDocument.vue?vue&type=style&index=0&id=a61305f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61305f0",
  null
  
)

export default component.exports